import { render, staticRenderFns } from "./LicitacionesView.vue?vue&type=template&id=88f02dd4"
import script from "./LicitacionesView.vue?vue&type=script&lang=ts"
export * from "./LicitacionesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports